module.exports = __webpack_public_path__ + "static/media/yash-display.da1a53bc.png";